import React, { memo } from 'react';
import { NamedLink } from '../../components';
import Icons from '../../components/Icons/Icons';
import css from './ListingPage.module.css';
import { FormattedMessage } from 'react-intl';

const BreadCrumbs = ({ categoryLabel, listingTitle, categorySearch }) => {

  return (
    <div className={css.breadcrumbs}>
      <>
        <NamedLink className={css.link} name="SearchPage">
          <FormattedMessage id="BreadCrumbs.searchPageText"/>
        </NamedLink>
        <Icons name="nextArrow" />
      </>

      <>
        <NamedLink className={css.link} name="SearchPage" to={{ search: categorySearch }}>
          {categoryLabel || 'Category'}
        </NamedLink>

        {/* <Icons name="nextArrow" /> */}
      </>

      {/* <span className={css.current}>{listingTitle || ''}</span> */}
    </div>
  );
};

export default memo(BreadCrumbs);
